<template>
  <div>
    <div class="border-b">
      <slot name="header" />
    </div>

    <div
      class="grid-plugins grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8"
    >
      <template
        v-for="(developer, developerKey) in developers"
        :key="developerKey"
      >
        <div class="grid-box border-b dark:border-gray-700">
          <div class="flex items-center py-6">
            <div class="bg-red-500 rounded-full w-16 h-16 mr-4">
              <!-- Developer icon -->
            </div>

            <div class="developer-card">
              <h3 class="font-bold">
                {{ developer.name }}
              </h3>

              <ul>
                <li>3 plugins</li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {computed, onMounted, toRefs, useDeveloperIndexStore} from '#imports';

  const props = defineProps<{
    requestData: object;
  }>();

  const {requestData} = toRefs(props);

  const developerIndexStore = useDeveloperIndexStore();
  const developers = computed(() => developerIndexStore.developers);

  const requestDevelopers = () => {
    developerIndexStore.searchDevelopers({
      ...requestData.value,
    });
  };

  onMounted(() => {
    requestDevelopers();
  });
</script>
